export const MODAL_ID = 'permissions-role-modal';
